module.exports = __webpack_public_path__ + "static/media/Multiple_Logo.a3d4f264.png";